function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Button, Input, Alert, notification } from "antd";
import Common from "../includes/Common";
import { Editor } from "@tinymce/tinymce-react";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";

var AddBusinessProvider = function AddBusinessProvider(_ref) {
  var handler = _ref.handler;

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      errorMessage = _useState2[0],
      setErrorMessage = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFormProcessing = _useState4[0],
      setIsFormProcessing = _useState4[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setIsFormProcessing(true);
    var fd = new FormData();
    fd.append("name", values.name);
    fd.append("mobile", values.mobile);
    fd.append("origin", values.origin);
    fd.append("user_id", Common.currentUser.id);
    axios.post(Common.baseApiUrl + "addbusinessprovider", fd).then(function (response) {
      if (response.data.status == 200) {
        handler();
        notification.success({
          message: "Ok!",
          description: response.data.message
        });
      } else setErrorMessage(response.data.message);
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue " + error.toString());
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onFinish,
      form: form,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Nom complet",
        name: "name",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "T\xE9l\xE9phone",
        name: "mobile",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Origine",
        name: "origin",
        rules: [{
          required: true,
          message: "Ce champ est obligatoire"
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "AJOUTER"
          })
        })
      })]
    })
  });
};

export default AddBusinessProvider;